import { render, staticRenderFns } from "./ConsteelBadge.svg.vue?vue&type=template&id=f9895986"
import script from "./ConsteelBadge.svg.vue?vue&type=script&lang=ts"
export * from "./ConsteelBadge.svg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9895986')) {
      api.createRecord('f9895986', component.options)
    } else {
      api.reload('f9895986', component.options)
    }
    module.hot.accept("./ConsteelBadge.svg.vue?vue&type=template&id=f9895986", function () {
      api.rerender('f9895986', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/ConsteelBadge.svg.vue"
export default component.exports